var _path, _path2, _path3, _rect, _path4, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddIllustration = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 130,
    viewBox: "0 0 230 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H222C226.418 0 230 3.58172 230 8V130H0V8Z",
    fill: "#ECE7FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77 28.5H153C157.142 28.5 160.5 31.8579 160.5 36V94C160.5 98.1421 157.142 101.5 153 101.5H77C72.8579 101.5 69.5 98.1421 69.5 94V36C69.5 31.8579 72.8579 28.5 77 28.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77 28.5H153C157.142 28.5 160.5 31.8579 160.5 36V94C160.5 98.1421 157.142 101.5 153 101.5H77C72.8579 101.5 69.5 98.1421 69.5 94V36C69.5 31.8579 72.8579 28.5 77 28.5Z",
    stroke: "#B19DFB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 40,
    width: 22,
    height: 22,
    rx: 11,
    fill: "#8B6CF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114.5 54.5V51.5H111.5C111.224 51.5 111 51.2761 111 51C111 50.7239 111.224 50.5 111.5 50.5H114.5V47.5C114.5 47.2239 114.724 47 115 47C115.276 47 115.5 47.2239 115.5 47.5V50.5H118.5C118.776 50.5 119 50.7239 119 51C119 51.2761 118.776 51.5 118.5 51.5H115.5V54.5C115.5 54.7761 115.276 55 115 55C114.724 55 114.5 54.7761 114.5 54.5Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 5,
    rx: 2.5,
    transform: "matrix(1 0 0 -1 81 77)",
    fill: "#ECE7FE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 5,
    rx: 2.5,
    transform: "matrix(1 0 0 -1 81 90)",
    fill: "#ECE7FE"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddIllustration);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/addIllustration.97a3f96330e1e0e02b8f7ce9dbed3a7e.svg";